import { Controller } from '@hotwired/stimulus';
import i18n from '../init/i18n';

export default class extends Controller {
  static targets = ['counter', 'notification'];

  connect() {
    this.refreshCount();
  }

  refreshCount(_) {
    const count = document.querySelector('[data-filters-count]').dataset
      .filtersCount;
    const content = i18n.t('filters_count', { count });

    if (this.hasCounterTarget) {
      this.counterTarget.innerText = count === '0' ? '' : content;
    }
    if (this.hasNotificationTarget) {
      if (count == 0) {
        this.notificationTarget.classList.add('d-none');
      } else {
        this.notificationTarget.classList.remove('d-none');
        this.notificationTarget.innerText = count;
      }
    }
  }
}
